
import { mapState, mapActions } from 'vuex'

const globalLoader = {
  computed: {
    ...mapState({
      globalLoaderVisible: ({ globalLoader }) => globalLoader.visible
    })
  },

  methods: {
    ...mapActions({
      openGlobalLoader: 'globalLoader/open',
      closeGlobalLoader: 'globalLoader/close'
    })
  }
}

export default globalLoader
